// src/components/LevelCard.jsx
import { useEffect, useState } from 'react';
import LessonCard from './LessonCard.jsx';
import ExamCard from './ExamCard.jsx';
import './LevelCard.css';

// El componente ahora recibe la nueva prop 'lessonsProgress'
// `exams`: los exámenes PUBLICADOS de este nivel — van al final de la cuadrícula,
// como la meta del nivel. Si no hay ninguno, el hueco queda vacío (a propósito).
function LevelCard({ level_code, title, description, lessons, lessonsProgress, foco, halladaId, exams }) {
  /* ── SE ABRE SOLO SI DENTRO HAY ALGO QUE LE DUELE ────────────────────────
     Un contorno amarillo solo sirve si el alumno acierta a abrir el nivel
     correcto. Se midió con un caso real: sus tres temas marcados estaban en A1
     y A2, él tenía A1 abierto, y los dos de A2 no existían para él.

     Marcar y esconder es peor que no marcar: el trabajo está hecho y no llega. */
  const tieneFoco = (foco || []).some(t =>
    (lessons || []).some(l => l.id === t.lesson_id));
  const [isExpanded, setIsExpanded] = useState(tieneFoco);

  /* Si la clase buscada vive aquí dentro, el nivel se abre — aunque el alumno
     lo tuviera plegado. Llevarle a una tarjeta escondida detrás de un acordeón
     cerrado es no llevarle a ninguna parte. */
  const contieneHallada = (lessons || []).some(l => l.id === halladaId);
  useEffect(() => {
    if (contieneHallada) setIsExpanded(true);
  }, [contieneHallada]);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  // Ya no simulamos los estados, los calcularemos con datos reales
  const icons = ['⭐', '📝', '📚', '📰', '👤', '🎯', '💎', '👆', '📍', '⭐', '🚀', '⏰', '💪', '✌️', '🥸', '🤑', '😁', '🙂', '🤓', '🦸'];

  return (
    <div className="lc-level-accordion">
      <div className="lc-level-header" onClick={toggleExpansion}>
        <div className="lc-level-icon">{level_code}</div>
        <div className="lc-level-info-text">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        {tieneFoco && !isExpanded && (
          <span className="lc-foco-aviso" title="Aquí hay temas que te tocan">
            ● {(foco || []).filter(t => (lessons || []).some(l => l.id === t.lesson_id)).length}
          </span>
        )}
        <button className={`lc-expand-button ${isExpanded ? 'expanded' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
      </div>

      <div className={`lc-lessons-container ${isExpanded ? 'expanded' : ''}`}>
        <div className="lc-topics-grid">
          {lessons.map((lesson, index) => {
            // Para cada lección, buscamos su información de progreso correspondiente
            const progressInfo = lessonsProgress?.find(p => p.lesson_id === lesson.id);
            // Si encontramos progreso, usamos su porcentaje. Si no, es 0.
            const percentage = progressInfo ? progressInfo.percentage : 0;

            /* El motivo por el que esta lección le toca, si el examen la marcó.
               Se apaga sola cuando la termina: `percentage >= 100` significa que
               ya no le duele, y una marca que no se apaga deja de indicar nada. */
            const marcada = foco?.find(t => t.lesson_id === lesson.id);
            const motivo = (marcada && percentage < 100) ? marcada.motivo : null;
            
            return (
              <LessonCard
                key={lesson.id}
                id={lesson.id}
                title={lesson.title}
                // ¡Le pasamos el porcentaje real a la LessonCard!
                percentage={percentage}
                foco={motivo}
                hallada={lesson.id === halladaId}
                icon={icons[index % icons.length]}
              />
            );
          })}

          {/* La meta del nivel: sus exámenes publicados, al final de la rejilla. */}
          {(exams || []).map((ex) => (
            <ExamCard
              key={ex.code}
              code={ex.code}
              title={ex.title}
              nReactivos={ex.n_reactivos}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default LevelCard;